/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Student request to accept a module version upgrade offer.
 */
export interface ModuleUpgradeAcceptRequest {
  targetVersion: string;
  acknowledgeTaskChanges?: boolean;
  acknowledgeGradeChange?: boolean;
}
